export default (url, queryParams) => {
  const [pathAndQuery, hash = ''] = url.split('#');
  const [path, queryString = ''] = pathAndQuery.split('?');
  const searchParams = new URLSearchParams(queryString);

  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      searchParams.set(key, value);
    });
  }

  return `${path}${searchParams.toString() ? '?' : ''}${searchParams}${hash ? '#' : ''}${hash}`;
};
